import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useFavorites } from "../context/FavoritesContext";

export const askLogin = (navigate) =>
  toast("Connectez-vous pour garder vos coups de cœur", {
    action: { label: "Se connecter", onClick: () => navigate("/login") },
  });

export default function FavoriteButton({ productId, className = "" }) {
  const { user } = useAuth();
  const { isFavorite, toggleFavorite } = useFavorites();
  const navigate = useNavigate();
  const active = isFavorite(productId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) return askLogin(navigate);
    const added = await toggleFavorite(productId);
    if (added === null) toast.error("Oups, réessayez dans un instant");
    else toast.success(added ? "Ajouté à vos favoris" : "Retiré de vos favoris");
  };

  return (
    <button
      className={`bg-white/90 backdrop-blur p-2 rounded-full hover:bg-white hover:scale-110 transition-transform ${className}`}
      onClick={onClick}
      aria-label={active ? "Retirer des favoris" : "Ajouter aux favoris"}
      aria-pressed={active}
      data-testid={`favorite-btn-${productId}`}
    >
      <Heart size={16} strokeWidth={1.5} className={`text-terracotta transition-colors ${active ? "fill-[#D7334F]" : ""}`} />
    </button>
  );
}
